const actionTypes = {
  STORE_DEFAULT_PRICES: 'STORE_DEFAULT_PRICES',
  CHANGE_OBSERVED_AUCTION: 'CHANGE_OBSERVED_AUCTION',
  AUCTIONS_MANAGEMENT_SET_FILTER: 'AUCTIONS_MANAGEMENT_SET_FILTER',
  AUCTIONS_LIVE_AUCTIONS_UPDATE: 'AUCTIONS_LIVE_AUCTIONS_UPDATE',
};

export default actionTypes;
